import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class stdClassListService {
  // 校验实体类型能否变更接口
  static async checkClassType(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClass/check-class-can-change-type?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getClassListTree(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClass/class-tree', payload))
    return Callback(err, res)
  }

  static async getClassList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getIsContainChildClass(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClass/query_have_child_class_by_id?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async saveClassList(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClass', payload))
    return Callback(err, res)
  }
  static async updateClassList(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClass', payload))
    return Callback(err, res)
  }
  static async classDetail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(wizStandardInstance.get(`/api/std/StdClass/?id=${payload.id}`))
    return Callback(err, res)
  }
  static async publish(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/publish?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 取消批量发布
  static async cancelPublish(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClass/publish-class-cancel-list', payload)
    )
    if (res.data.code === 1 && res.data.data === 'confirmTip') {
      res.data.code = 0
      return Callback(err, res)
    }
    return Callback(err, res)
  }
  // 新批量发布
  static async newPublishList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClass/publish-class-list', payload)
    )
    if (res.data.code === 1 && res.data.data === 'confirmTip') {
      res.data.code = 0
      return Callback(err, res)
    }
    return Callback(err, res)
  }

  // 获取发布进度
  static async getPublishProgress(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Common/redis-progress/${payload}`)
    )
    return Callback(err, res)
  }

  // 批量发布
  static async publishList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/publish_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 批量未发布
  static async unpublishList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClass/modify-unpublished-list', payload)
    )
    return Callback(err, res)
  }
  static async updateApproveStatus(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/update_approve_status?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async classRemove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance('/api/std/StdClass', {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async getAttrList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async saveAttrList(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async getStandardAttrList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async updateAttrList(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClass/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }

  // 新增属性分组
  static async addAttributeGroup(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttributeGroup', payload)
    )
    return Callback(err, res)
  }
  // 获取属性分组列表
  static async getAttributeGroupList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttributeGroup/get-group-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取属性分组
  static async getAttributeGroup(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttributeGroup/${payload}`)
    )
    return Callback(err, res)
  }
  // 编辑属性分组
  static async updateAttributeGroup(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/StdClassAttributeGroup/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除属性组
  static async removeAttributeGroup(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance(`/api/std/StdClassAttributeGroup/${payload}`, {
        method: 'delete',
      })
    )
    return Callback(err, res)
  }
  // 设置分组
  static async setAttributeGroup(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttributeGroup/set-group', payload)
    )
    return Callback(err, res)
  }
  // 移除分组
  static async moveGroup(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttributeGroup/move-group', payload)
    )
    return Callback(err, res)
  }
  // 获取实体列表
  static async getClassListPage(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClass/get-class-list-page', payload)
    )
    return Callback(err, res)
  }
  // 判断实体是否发布过
  static async checkIsPublished(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/check-is-published/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 新增获取实体最大序号值
  static async getClassMaxSeqno(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/max-seqno?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增获取属性最大序号值
  static async getAttrMaxSeqno(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute/max-seqno?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 实体属性影响分析
  static async getImpactAnalysis(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute/impact-analysis/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 实体属性血缘分析
  static async getAncestryAnalysis(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute/ancestry-analysis/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 标准属性影响分析
  static async getAttrImpactAnalysis(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttribute/impact-analysis/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 下载拓展属性模板
  static async downloadExtendedTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdClassExtendClass/down_import_template', {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 导入拓展属性
  static async importExtended(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassExtendClass/import', payload)
    )
    return Callback(err, res)
  }
}
